import { Component, ElementRef, inject, OnInit, signal, viewChild } from "@angular/core";
import { Router, RouterModule } from "@angular/router";
import { CurrentUserService } from "../../shared/CurrentUser.service";
import { INavCategory } from "../../shared/interfaces/INavCategory";
import { AppInfoService } from "../../singletons/app-info.service";
import { CtrlClickDirective } from "../../directives/ctrl-click.directive";

@Component({
  selector: 'app-header',
  templateUrl: 'header.component.html',
  standalone: true,
  imports: [RouterModule, CtrlClickDirective]
})
export class AppHeaderComponent implements OnInit {
  private service = inject(AppInfoService);
  private userService = inject(CurrentUserService)
  private router = inject(Router);

  protected mainMenu: INavCategory[] = [{
    name: 'Home', items: [{ name: 'Home Screen', url: '/home' }]
  }, {
    name: 'Vendors', url: '/vendors'
  }, {
    name: 'Quotes', url: '/quotes'
  }, {
    name: 'Invoices', url: '/invoices'
  }, {
    name: 'Agreements', url: '/agreements'
  }];

  protected environmentName = signal('');
  protected UserDisplayName = signal('');
  protected profilePicture = viewChild.required<ElementRef<HTMLImageElement>>("profilePicture");

  ngOnInit() {
    this.service.getAppStartupInfo().subscribe((info) => {
      if (info)
        this.environmentName.set(info.EnvironmentName);
    });

    this.userService.IsLoggedIn().subscribe((isLoggedIn) => {
      if (isLoggedIn === true) {
        this.UserDisplayName.set(this.userService.GetRawUser().name);

        try {
          this.userService.GetProfilePictureIcon().subscribe(pic => {
            this.profilePicture().nativeElement.setAttribute("src", pic);
          });
        } catch { };
      }
    });
  }

  protected viewDiagProfile() {
    this.router.navigate(["/diagnostic-profile"])
  }
}
